import React from "react";
import { useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES, WEIGHT } from "theme";
import { CNG_COST, DIESEL_COST, PETROL_COST } from "utils";

const FuelType = ({ small, getDetails }) => {
  const [val, setVal] = useState("diesel");
  const handleChange = (e) => {
    const { value } = e.target;
    setVal(e.target.value);
    switch (value) {
      case "diesel":
        return getDetails(value, "fuel", DIESEL_COST);
      case "petrol":
        return getDetails(value, "fuel", PETROL_COST);
      case "cng":
        return getDetails(value, "fuel", CNG_COST);
      default:
        return getDetails(value, "fuel", DIESEL_COST);
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box
        background="#1C1C1C"
        b={small ? "none" : "1px solid #333333"}
        marginTop={small ? "0px" : "10px"}
      >
        <Box margin="20px">
          <Text
            fontSize={small ? SIZES.fourteen : "16px"}
            fontWeight="bold"
            textColor="white"
          >
            Fuel Type
          </Text>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <div
              className="radio_container"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: small && 0,
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Box display="flex" alignItems="center">
                <input
                  className="radio_box"
                  type="radio"
                  style={{
                    width: small ? "fit-content" : "25px",
                    height: small ? "fit-content" : "25px",
                    accentColor: COLORS.primary,
                  }}
                  name="fuel"
                  id="diesel"
                  required
                  value={"diesel"}
                  checked={val === "diesel"}
                  onChange={handleChange}
                />

                <label
                  className="radio_label"
                  for="diesel"
                  style={{
                    color: COLORS.white,
                    fontWeight: WEIGHT.bold,
                    fontSize: small ? SIZES.fourteen : SIZES.fourteen,
                    cursor: "pointer",
                    marginLeft: 5,
                  }}
                >
                  Diesel
                </label>
              </Box>
              <div className="radio_container">
                <Box display="flex" alignItems="center">
                  <input
                    className="radio_box"
                    type="radio"
                    style={{
                      width: small ? "fit-content" : "25px",
                      height: small ? "fit-content" : "25px",
                      accentColor: COLORS.primary,
                    }}
                    name="fuel"
                    id="petrol"
                    required
                    value={"petrol"}
                    checked={val === "petrol"}
                    onChange={handleChange}
                  />

                  <label
                    className="radio_label"
                    for="petrol"
                    style={{
                      color: COLORS.white,
                      fontWeight: WEIGHT.bold,
                      fontSize: small ? SIZES.fourteen : SIZES.fourteen,
                      cursor: "pointer",
                      marginLeft: 5,
                    }}
                  >
                    Petrol
                  </label>
                </Box>
              </div>
              <Box display="flex" alignItems="center">
                <input
                  className="radio_box"
                  type="radio"
                  style={{
                    width: small ? "fit-content" : "25px",
                    height: small ? "fit-content" : "25px",
                    accentColor: COLORS.primary,
                  }}
                  name="fuel"
                  id="cng"
                  required
                  value={"cng"}
                  checked={val === "cng"}
                  onChange={handleChange}
                />

                <label
                  className="radio_label"
                  for="cng"
                  style={{
                    color: COLORS.white,
                    fontWeight: WEIGHT.bold,
                    fontSize: small ? SIZES.fourteen : SIZES.fourteen,
                    cursor: "pointer",
                    marginLeft: 5,
                  }}
                >
                  CNG
                </label>
              </Box>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FuelType;
